<template>
  <div class="mt-4">
    <div class="row">
      <!-- Content type navigation -->
      <tab-nav
        class="col pl-2 pr-2"
        coloredBackground
        :active="getCurrentType"
        :tabs="availableTypes" />

    </div>

    <!-- Content list -->
    <div
      v-if="getCurrentType"
      class="row editor-wrapper">

      <table class="table col">
        <thead>
          <tr>
            <th>{{ $t('Editor.key') }}</th>

            <!-- Available languages -->
            <th
              v-for="i in availableLanguages"
              :key="i.val"
              v-html="i.label" />

          </tr>
        </thead>

        <tbody>
          <tr
            v-for="[id, value] in groupContent"
            :key="id">

            <td class="key">
              {{ value.key }}
            </td>

            <!-- Existing translations & empty boxes for new ones -->
            <td
              class="language-content"
              v-for="{ value: language } in availableLanguages"
              :key="language">

              <component
                class="limit-cell"
                :is="getContentEditor"
                :editObject="value.languages[language]"
                :contentType="getCurrentType"
                @updateContent="updateContent($event, value, language)" />

            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import EmailEditor from '@/components/service/administration/editor/EmailEditor'
import PageEditor from '@/components/service/administration/editor/PageEditor'
import SnippetEditor from '@/components/service/administration/editor/SnippetEditor'

import TabNav from '@/components/standard/action/TabNav'

import content from '@/mixins/pagination/providers/content'
import apiConnector from '@/mixins/apiConnector'

import fieldBuilder from '@/assets/modules/apollo/fieldBuilder'
import manager from '@/assets/modules/notifications/manager'
import resolver from '@/assets/modules/error/resolver'
import paramExtractor from '@/assets/modules/channels/paramExtractor'

import availableItems from '@/assets/configurations/avalableItems'

import localStorageHelper from '@/assets/modules/localStorageHelper'

const TYPE_EDITORS = { snippet: 'snippet-editor', email: 'email-editor', page: 'page-editor' }

export default {
  data () {
    return {
      availableTypes: [
        {
          label: 'Snippets',
          name: 'snippet',
          route: 'ContentEditor',
          params: { type: 'snippet' }
        },

        {
          label: 'Email',
          name: 'email',
          route: 'ContentEditor',
          params: { type: 'email' }
        },

        {
          label: 'Page content',
          name: 'page',
          route: 'ContentEditor',
          params: { type: 'page' }
        }
      ]
    }
  },

  methods: {
    /**
     * Prepares GQL object to update or create the content
     * @param {Object} e Editor's event
     * @param {Object} meta Snippet's meta
     * @param {String} language
     * @param {String} contentType
     * @returns {Object}
     */
    prepareGqlObject (e = {}, meta = {}, language = null, contentType = null) {
      // If entry exists - update; else insert new
      let { key } = meta
      let { content } = e
      let { id } = e.meta || {}

      let updateExisting = !!id

      // Prepare object...
      let gqlObject = { id, key, type: contentType, language }
      gqlObject[contentType] = content

      // Remove unneded keys...
      if (!updateExisting) {
        delete gqlObject.id
      } else {
        delete gqlObject.key
        delete gqlObject.language
      }

      return gqlObject
    },

    /**
     * Updates or creates new content
     * @param {Object} e Event
     * @param {Object} meta Content's meta
     * @param {String} language Contebt's language
     */
    updateContent(e, meta, language) {
      let gqlObject = this.prepareGqlObject(e, meta, language, this.getCurrentType)

      // Mutate...
      let okCallback = (e) => {
        manager.okNotification(this, 'Notification.ok.contentUpdated.label')
        this.$apollo.queries.content.refetch()
      }

      let failCallback = (_, e) => {
        let message = resolver.resolve(e.message)
        manager.nokNotification(this, message)
      }

      let {mutationString, dataObject, name} = fieldBuilder
        .buildGqlObject(gqlObject, 'storeContent', 'mutation', [], {
          type: 'ContentType',
          key: 'String',
          language: 'Language',
          page: 'ContentPageInput',
          email: 'ContentEmailInput',
          snippet: 'ContentSnippetInput'
        })

      this.sendMutation(
        mutationString,
        dataObject,
        okCallback,
        failCallback,
        name)
    }
  },

  computed: {
    /**
     * Gives current content type
     * @returns {String}
     */
    getCurrentType () {
      return this.$route.params.type
    },

    /**
     * Gives content editor for given type
     * @returns {String}
     */
    getContentEditor () {
      return TYPE_EDITORS[this.getCurrentType]
    },

    /**
     * Gives available languages
     * @returns {Array}
     */
    availableLanguages () {
      return availableItems.UserSettings.interfaceLanguages.filter(l => !l.hide).reverse()
    }
  },

  components: {
    'email-editor': EmailEditor,
    'page-editor': PageEditor,
    'snippet-editor': SnippetEditor,
    'tab-nav': TabNav
  },

  mixins: [
    content,
    apiConnector
  ]
}
</script>

<style scoped>
.editor-wrapper {
  background-color: white;
}

.limit-cell {
  word-break: break-word;
}

tr .key {
  width: 20%;
}

tr .language-content {
  width: 40%;
}

.lang-switch {
  text-decoration: underline;
  color: blue;
  font-size: 12px;
  margin-right: 5px;
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/service/administration/ContentEditor.vue?5e017a19